<div class="AmCalendar">
  <div class="AmCalendar-header">
    <span class="fs-32px fw-medium-x lh-42px">{{ 'srIrops.calendar.selectDate' | translate }}</span>
    <img alt="" src="../../../../assets/images/close-X.svg" (click)="onClose()" />
  </div>
    <div class="AmCalendar-body">
      <div class="AmCalendar-months">
        <am-calendar-month
          [currentDate]="currentDay.toDate()"
          [monthSelected]="monthSelected"
        ></am-calendar-month>
      </div>
      <app-am-scroll [height]="650">
        <div style="height: 650px;" id="containerMonth">
          <div class="AmCalendar-days"
            *ngFor="let month of calendars; let i = index;"
            [id]="'list-item-' + month.id"
            [tabIndex]="i"
          >
            <span class="AmCalendar-monthName fs-24px lh-32px fw-medium-x">
              {{ month.titleMonth | titlecase }}
            </span>
            <div class="AmCalendar-contentDays">
              <table class="AmCalendar-table">
                <thead>
                  <tr>
                    <th class="fs-24px fw-regular lh-32px"
                      *ngFor="let dayWeek of ['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun']">
                      {{ ('srIrops.calendar.' + dayWeek) | translate }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let week of month.calendarMap">
                    <td *ngFor="let day of week; let x = index;">
                      <am-calendar-item
                        [calendar]="day"
                        class="AmCalendar-dayItem"
                        [currentDate]="currentDay.toDate()"
                        (selected)="catchDateSelected($event)"
                        *ngIf="day"
                      ></am-calendar-item>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </app-am-scroll>
    </div>
</div>